import { TActions } from '../../../types/actions';
import { IPublishAvailableState } from './types';
import { NEED_IDENTIFICATION, PUBLISH_TO_HIDDEN_BASE } from './actions';

export const defaultState: IPublishAvailableState = {
  isIdentificationNeeded: false,
  isPublishToHiddenBase: false,
};

export function publishAvailable(
  state: IPublishAvailableState = defaultState,
  action: TActions,
): IPublishAvailableState {
  switch (action.type) {
    case NEED_IDENTIFICATION: {
      return {
        ...state,
        isIdentificationNeeded: action.payload,
      };
    }

    case PUBLISH_TO_HIDDEN_BASE: {
      return {
        ...state,
        isPublishToHiddenBase: action.payload,
      };
    }

    default:
      return state;
  }
}
